import { AccountDietaryRestrictionsScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <AccountDietaryRestrictionsScreen headerShown />;
}
